import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserRequestPage, ModalAgainRequestPage, ModalSetPage } from './userRequest';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    UserRequestPage,
    ModalAgainRequestPage,
    ModalSetPage,
  ],
  imports: [
    IonicPageModule.forChild(UserRequestPage),
  ],

  entryComponents: [
    ModalAgainRequestPage,
    ModalSetPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class UserRequestPageModule {}



// WEBPACK FOOTER //
// ./src/pages/userRequest/userRequest.module.ts